import io from 'socket.io-client';
import { socketConnection } from '../constants/connection.js';

//socketConnection is set with global env. Can be used everywhere where sockets are needed.
export const SocketConnection = io(socketConnection, { transports : ['websocket'] });
